import { render, staticRenderFns } from "./main-submenu.vue?vue&type=template&id=235a110a&scoped=true&"
import script from "./main-submenu.vue?vue&type=script&lang=ts&"
export * from "./main-submenu.vue?vue&type=script&lang=ts&"
import style0 from "./main-submenu.vue?vue&type=style&index=0&id=235a110a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a110a",
  null
  
)

export default component.exports